<template>
  <div @click="onclick" class="ta-auction-list-item-thumb">
    <router-link :to="auctionViewRoute">
      <img v-if="imageSrc" :src="imageSrc"/>
      <img v-else src="https://cdn.artisio.co/no_image.jpg">
    </router-link>
  </div>
</template>

<script>
import auctionViewRoute from "@/mixins/auctionHelperMixin.js";
import {auctionView} from "@/triggers";

export default {
  name: "AuctionImage",
  mixins: [auctionViewRoute],
  props: {
    auction: {
      required: true,
      type: Object
    },
  },
  methods: {
    onclick() {
      auctionView(this.auction)
    }
  }
}
</script>

<style scoped>

</style>
